<div class="section section-hero has-spacer" [class.dark]="darkMode" id="top" lazyBg
  [url]="darkMode ? 'assets/img/bg_dark2.webp' : 'assets/img/bg_light2.webp'">
  <div class="contents-wrapper">
    <div class="contents bg-light">
      <div class="section-header">
        <div class="headline">
          <span class="greeting" [innerHTML]="'hero.greeting' | translate"></span> <strong
            class="name text-primary">Sebi</strong>.
          <span class="subtitle" [innerHTML]="'hero.subtitle' | translate"></span>
        </div>
      </div>

      <p class="description" [innerHTML]="'hero.description' | translate"></p>

      <ion-button size="large" color="secondary" class="cta animate__animated animate__bounceIn"
        href="https://ko-fi.com/sebidev" target="_blank">
        <img class="icon" src="assets/img/kofi_s_logo_nolabel.png" alt="ko-fi logo">{{ 'hero.support-me' | translate }}
      </ion-button>

      <ion-button class="cta animate__animated animate__bounceIn" size="large" (click)="shouldScrollToElement('hello')">
        {{'hero.cta' | translate}}
      </ion-button>
    </div>
  </div>

  <ion-button class="scroll-next animate__animated animate__zoomInDown" fill="clear" size="large" *ngIf="scrollToId"
    (click)="shouldScrollToElement(scrollToId)">
    <ion-icon slot="icon-only" name="caret-down-outline"></ion-icon>
  </ion-button>
</div>